import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router';
import { FiltersModal } from '../../components/filters/FiltersModal';
import { IProjectDetailsImagesBl } from '../../projectDetailsImages.bl';
import { IProjectDetailsImagesStore } from '../../projectDetailsImages.store';

interface IProps {
  isOpen: boolean;
  toggle: () => void;
}

interface RouteParams {
  workspaceId: string;
  projectId: string;
  filterId: string;
}

export const FiltersContainer = observer((props: IProps): ReactElement => {
  const projectDetailsImagesStore = useInjection(IProjectDetailsImagesStore.$);
  const projectDetailsImagesBl = useInjection(IProjectDetailsImagesBl.$);

  const { projectId, filterId } = useParams<RouteParams>();

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      await projectDetailsImagesBl.getImageTabDataAsync(projectId, filterId);
    };

    void fetchData();
  }, [projectId, filterId]);

  const { availableFilters, imageFilters } = projectDetailsImagesStore;

  return (
    <FiltersModal
      availableFilters={availableFilters}
      imageFilters={imageFilters}
      isOpen={props.isOpen}
      toggle={props.toggle}
    />
  );
});
